import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SellerLeadMagnet } from "@/components/SellerLeadMagnet";
import { useSiteBranding } from "@/context/SiteContext";
import { useSeo } from "@/hooks/useSeo";

export const SellPage = () => {
  const { buildBrandedPath, getWhatsAppHref } = useSiteBranding();

  useSeo({
    title: "Sell | SG Prop Portal",
    description: "Request valuation guidance, understand district positioning, and start selling with clearer next steps.",
  });

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,#fbf6e7_0%,#f7efdf_46%,#e4ebf2_100%)] text-[#001935]" data-testid="sell-page">
      <section className="section-shell pt-10">
        <div className="grid gap-8 rounded-[36px] border border-[#001935]/10 bg-white/92 p-8 shadow-[0_22px_60px_rgba(0,25,53,0.08)] lg:grid-cols-[0.95fr_1.05fr] lg:p-10">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#8b6d16]" data-testid="sell-page-kicker">Sell</p>
            <h1 className="mt-3 text-4xl font-semibold leading-tight text-[#001935] md:text-5xl" data-testid="sell-page-heading">
              Start with valuation clarity before your property goes live.
            </h1>
            <p className="mt-4 text-sm leading-8 text-[#42566f] md:text-base" data-testid="sell-page-copy">
              Use SG Prop Portal to line up pricing guidance, seller positioning, and direct advisory support before you commit to the next listing move.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a className="gold-button" data-testid="sell-page-whatsapp-button" href={getWhatsAppHref("Hello SG Prop Portal, I want help selling my property.")} rel="noreferrer" target="_blank">
                Talk to the Team <ArrowRight className="ml-2 h-4 w-4" />
              </a>
              <Link className="outline-button" data-testid="sell-page-financials-button" to={buildBrandedPath("/financials")}>
                Review Financials
              </Link>
            </div>
          </div>

          <div className="grid gap-4" data-testid="sell-page-proof-grid">
            {[
              "Valuation-first seller entry",
              "District context before pricing decisions",
              "WhatsApp-first human follow-up",
            ].map((item) => (
              <div className="rounded-[24px] border border-[#001935]/10 bg-[#fffaf1] px-5 py-5" data-testid={`sell-page-proof-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} key={item}>
                <p className="text-sm font-semibold text-[#001935]">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-shell pb-14 pt-8">
        <SellerLeadMagnet
          contextLabel="Sell page valuation request"
          description="Request a free property valuation or unlock the 2026 Market Insights PDF to understand pricing signals, buyer behaviour, and seller positioning."
          heading="Get your valuation brief started."
          testIdPrefix="sell-page-seller-magnet"
        />
      </section>
    </div>
  );
};